<template>
  <section class="bloc-text-image" :class="{ 'has-border' : content.border }">
    <div class="bloc-text-image__wrapper">
      <h2 class="bloc-text-image__title" v-html="content.title"></h2>
      <img svg-inline class="bloc-text-image__wave" src="@/assets/images/icons/wave.svg" />
      <h3 class="bloc-text-image__subtitle-1" v-html="content.subtitle"></h3>

      <img class="bloc-text-image__img" :src="require(`@/${content.img}`)">

      <h3 class="bloc-text-image__subtitle-2">{{ content.subtitle_two }}</h3>
      <p class="bloc-text-image__text">{{ content.text }}</p>

      <img svg-inline class="bloc-text-image__wave" src="@/assets/images/icons/wave.svg" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'TextImage',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-text-image {
    width: 100vw;
    background: $th-grey;
    padding: 80px 0 40px;
    overflow: hidden;
    position: relative;
    
    &.has-border {
      border-top: 10px solid $th-gold;
      border-bottom: 10px solid $th-gold;
    }

    &__wrapper {
      width: grid_m(5, 4);
      margin: 0 auto;

      @include media($from: small) {
        width: 100%;
      }
    }

    &__img {
      width: 100vw;
      height: 135vw;
      object-fit: cover;
      left: -$site-padding-mobile;
      position: relative;
      margin: 30px 0 50px;

      @include media($from: small) {
        left: 0;
        height: 54vw;
        margin: 50px 0 50px;
      }
    }

    &__title {
      position: relative;
      font-size: 22px;
      font-family: "Gotham Book";
      color: $th-cherry;
      text-align: center;
      display: block;
      line-height: 1.65;
      text-transform: uppercase;

      sup {
        font-size: 12px;
      }
    }

    &__subtitle-1 {
      color: $th-gold;
      text-align: center;
      display: block;
      text-transform: uppercase;
      font-family: "Gotham Book";
      font-size: 18px;
      line-height: 1.65;

      sup {
        font-size: 12px;
      }
    }

    &__subtitle-2 {
      color: $th-gold;
      text-align: center;
      display: block;
      text-transform: uppercase;
      font-family: "Gotham Book";
      font-size: 20px;
      line-height: 1.65;
    }

    &__text {
      position: relative;
      font-size: 20px;
      font-family: "Georgia";
      color: $th-grey;
      text-align: center;
      display: block;
      line-height: 1.5;
      margin-top: 30px;
      margin-bottom: 40px;

      @include media($from: small) {
        width: grid(6, 5);
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 40px;
      }
    }

    &__wave {
      margin: 20px auto;
      display: block;
    }
  }
</style>
